<style>
    .height-100 {
        height: 100%;
    }
</style>
<template>
    <div>
        <h2 style="text-align: center">欢迎使用晓麦云平台</h2>
        <card style="margin-top:10px;">
            <Row style=" height: 100px;" >
                <Col class="infor-card-icon-con"  span="24">
                    <Button @click="signup" type="primary">
                        <Row class="height-100" type="flex" align="middle" justify="center">
                            <div style="width:80px;height:80px;">
                                <Icon type="ios-people" :size="80"></Icon>
                            </div>
                            <div style="font-size: 20px;margin-left: 15px;">
                                报名新课程
                                <div style="font-size:12px">缴费+加课时+排课</div>
                            </div>
                        </Row>
                    </Button>

                    <Button @click="renew" type="primary" style="margin-left: 10px;">
                        <Row class="height-100" type="flex" align="middle" justify="center">
                            <div style="width:80px;height:80px;line-height: 80px;">
                                <Icon type="logo-yen" :size="50"></Icon>
                            </div>
                            <div style="font-size: 20px;margin-left: 10px;">
                                续费
                                <div style="font-size:12px">缴费+加课时</div>
                            </div>
                        </Row>
                    </Button>

                    <Button @click="presentHour" type="primary" style="margin-left: 10px;">
                        <Row class="height-100" type="flex" align="middle" justify="center">
                            <div style="width:80px;height:80px;line-height: 80px;">
                                <Icon type="md-add" :size="50"></Icon>
                            </div>
                            <div style="font-size: 20px;margin-left: 10px;">
                                赠送课时
                                <div style="font-size:12px">需总校审核</div>
                            </div>
                        </Row>
                    </Button>
                </Col>

            </Row>
        </card>
        <Row :gutter="10" style="margin-top:10px;">
            <Col span="12">
                <Card>
                    <p slot="title">
                        待续费
                        <span style="margin-left:10px;font-size: 12px;color:#666;font-weight: normal">
                            课时数小于排课数，或者课时数小于等于3的学员
                        </span>
                    </p>
                    <Table :columns="columns1" :data="data1" :loading="dataLoading1" >
                        <template slot-scope="{ row, index }" slot="classNum">
                            <span :style="{color:(row.class_num_remain < row.classNum ? 'red' : '#333')}">{{row.classNum}}</span>
                        </template>
                    </Table>
                </Card>
            </Col>
            <Col span="12">
                <Card>
                    <p slot="title">
                        待延期
                        <span style="margin-left:10px;font-size: 12px;color:#666;font-weight: normal">
                             一个月内即将到期并且课时将有剩余的学员
                        </span>
                    </p>
                    <Table :columns="columns2" :data="data2" :loading="dataLoading2" ></Table>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
  export default {
    name: 'home',
    data() {
      return {
        columns1:[
          {
            title:'学员',
            key:'studentName'
          },
          {
            title:'课程',
            key:'courseName'
          },
          {
            title:'当前剩余课时数',
            key:'class_num_remain'
          },
          {
            title:'一个月内排课数',
              slot: 'classNum'
            // key:'classNum'
          },
          {
            title:'校区',
            key:'zoneName'
          }
        ],
        data1:[],
        dataLoading1:false,
        columns2:[
          {
            title:'学员',
            key:'studentName'
          },
          {
            title:'课程',
            key:'courseName'
          },
          {
            title:'剩余课时',
            key:'class_num_remain'
          },
          {
            title:'剩余排课',
            key:'classNum'
          },
          {
            title:'最后上课日期',
            key:'last_date'
          },
          {
            title:'校区',
            key:'zoneName'
          },
        ],
        data2:[],
        dataLoading2:false
      }
    },
    mounted() {
      this.loadNotEnoughClassNumStudentList();
      this.loadBeOverplusStudentList();
    },
    methods: {
      loadNotEnoughClassNumStudentList(){
        let self = this;
        self.dataLoading1 = true;
        self.$api.student.getNotEnoughClassNumStudentList().then(resp=>{
          self.dataLoading1 = false;
          self.data1 = resp.list;
        });
      },
      loadBeOverplusStudentList(){
        let self = this;
        self.dataLoading2 = true;
        self.$api.student.getBeOverplusStudentList().then(resp=>{
          self.dataLoading2 = false;
          self.data2 = resp.list;
        });
      },
      signup() {
        this.$router.push({
          name: 'signup'
        })
      },
      renew() {
        this.$router.push({
          name: 'renew'
        })
      },
      presentHour(){
        this.$router.push({
          name: 'present_hour'
        })
      }
    }
  }
</script>

<style lang="less">
    .count-style {
        font-size: 50px;
    }
</style>
